import { useQuery } from '@tanstack/react-query';
import { Agenda } from '../types/agenda';
import { getAgendas } from '../service/agenda';

export const useAgenda = () => {
  return useQuery<Agenda[]>({
    queryKey: ['agenda'],
    queryFn: getAgendas,
  });
};
